import { useMemo } from 'react';

import { useBackgroundImage } from 'hooks/useBackgroundImage';
import { useImgix } from 'hooks/useImgix';

import c from './_backImage.module.scss';

import { animated, useTransition } from '@react-spring/web';
import clsx from 'clsx';
import { isNil } from 'lodash-es';

export interface BackImageProps {
  className?: string;
  blur?: boolean;
  darken?: boolean;
  src?: string;
}

export function NewBackImage({ className, blur = false, darken = false, src: srcProp }: BackImageProps) {
  const backgroundImage = useBackgroundImage();

  const src = useMemo(() => {
    if (isNil(srcProp)) {
      return backgroundImage;
    }

    return srcProp;
  }, [srcProp, backgroundImage]);

  const { src: imgixSrc } = useImgix(src, { imgix: { width: window.innerWidth } });

  const transitions = useTransition(imgixSrc, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return transitions((style, item) => {
    return (
      <animated.div
        className={clsx(
          c.wrapper,
          {
            [c.wrapperBlur]: blur,
            [c.wrapperDarken]: darken,
          },
          className,
          'backImage__wrapper',
        )}
        style={{ ...style, backgroundImage: `url(${item})` }}
      />
    );
  });
}
